import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import CaseFormWrapper from "components/Homeowner/CaseForms/CaseFormWrapper";

class SummaryCaseView extends React.Component {

    constructor(props) {
        super(props);
        this.constructColumnDefinitions = this.constructColumnDefinitions.bind(this);
        this.constructForm = this.constructForm.bind(this);
        this.constructForms = this.constructForms.bind(this);
        this.constructAllForms = this.constructAllForms.bind(this);
        this.constructFormsByColumn = this.constructFormsByColumn.bind(this);
        this.renderColumn = this.renderColumn.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.onFormClick = this.onFormClick.bind(this);
        this.isFormExpanded = this.isFormExpanded.bind(this);
        this.filterFormsById = this.filterFormsById.bind(this);
        this.state = {
            selectedFormId: null,
        };
    }

    constructColumnDefinitions() {
        const { columnDefinitions } = this.props;
        return {
            leftColumn: {
                forms: null,
                size: 4,
                className: "",
                ...columnDefinitions.leftColumn
            },
            rightColumn: {
                forms: null,
                size: 8,
                className: "",
                ...columnDefinitions.rightColumn
            },
        };
    }

    constructForm(form) {
        return {
            id: "1337",
            title: "placeholder",
            summaryInfo: null,
            content: null,
            ...form
        };
    }

    constructForms(forms) {
        return forms.map((form) => {
            return this.constructForm(form);
        });
    }

    constructAllForms() {
        const columnDefinitions = this.constructColumnDefinitions();
        const { leftColumn, rightColumn } = columnDefinitions;
        return {
            leftColumn: this.constructForms(leftColumn.forms),
            rightColumn: this.constructForms(rightColumn.forms),
        };
    }

    //column must be either "leftColumn" or "rightColumn"
    constructFormsByColumn(column) {
        const columnDefinitions = this.constructColumnDefinitions();
        const forms = columnDefinitions[column].forms;
        return this.constructForms(forms);
    }

    renderColumn(forms) {
        return (forms).map((form, index) => {
            return this.renderForm(this.constructForm(form), index);
        });
    }

    renderForm(form, index) {
        const formExpanded = this.isFormExpanded(form.id, index);
        if (form.wrap) {
            return (
                <div key={`${form.id} ${formExpanded} ${index}`} className="form">
                    <CaseFormWrapper
                        formId={form.id}
                        formTitle={form.title}
                        formStatusChange={() => { }}
                        comp={<div className="content">{form.content}</div>}
                        summaryInfo={() => (<div className="summary-info">{form.summaryInfo}</div>)}
                        onClick={this.onFormClick}
                        expandOnLoad={formExpanded}
                    />
                </div>
            );
        } else {
            return (
                <div key={`${form.id} ${formExpanded} ${index}`} className="form">
                    <div className="content">{form.content}</div>
                </div>
            );
        }
    }

    onFormClick(formExpanding, formId) {
        const { selectedFormId } = this.state;
        const leftColumnForms = this.constructFormsByColumn("leftColumn");
        if (formExpanding && selectedFormId !== formId && this.filterFormsById(leftColumnForms, formId).length > 0) {
            this.setState({
                selectedFormId: formId
            });
        }
    }

    isFormExpanded(formId, index) {
        const { selectedFormId } = this.state;
        return formId === selectedFormId || (!selectedFormId && index === 0);
    }

    filterFormsById(forms, formId) {
        return forms.filter(form => {
            return form.id === formId;
        });
    }

    render() {
        const { className } = this.props;
        const columnDefinitions = this.constructColumnDefinitions();
        const { leftColumn, rightColumn } = columnDefinitions;
        return (
            <Grid container spacing={2} style={{ margin: "inherit" }} //Temp inline style until we get away from using a grid
                className={`case-summary-view no-padding ${className}`}>
                <Grid item
                    className={`column left-column ${leftColumn.className}`}
                    xs={leftColumn.size}>
                    {this.renderColumn(leftColumn.forms)}
                </Grid>
                <Grid item
                    className={`column right-column ${rightColumn.className}`}
                    xs={rightColumn.size}>
                    {this.renderColumn(rightColumn.forms)}
                </Grid>
            </Grid>
        );
    }
}

SummaryCaseView.defaultProps = {
    className: "",
};

SummaryCaseView.propTypes = {
    className: PropTypes.string,
    columnDefinitions: PropTypes.object,
};
export default SummaryCaseView;